import { render, staticRenderFns } from "./CoursesAndSeminars.vue?vue&type=template&id=1d5d662e&scoped=true&"
import script from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"
export * from "./CoursesAndSeminars.vue?vue&type=script&lang=js&"
import style0 from "./CoursesAndSeminars.vue?vue&type=style&index=0&id=1d5d662e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d662e",
  null
  
)

export default component.exports